import API from '@/models/API';

export default class BusinessStatistics {
  static get = (query) =>
    API.get(`/companies/${localStorage.getItem('storeId')}/statistics${query}`);

  static getActiveUsers = () =>
    API.get(`/companies/${localStorage.getItem('storeId')}/statistics/active-users`);

  static getLast2MonthsActiveUsers = () =>
    API.get(`/companies/${localStorage.getItem('storeId')}/statistics/active-users-two-months`);

  static getCompanyRegions = () =>
    API.get(`/companies/${localStorage.getItem('storeId')}/network-regions`);
}
